import React from 'react';

interface AvatarProps {
  firstName?: string;
  lastName?: string;
  profileImageUrl?: string;
  size?: 'xs' | 'small' | 'medium' | 'large';
}

const sizeClasses = {
  xs: 'w-6 h-6 text-[10px]',
  small: 'w-10 h-10 text-xs',
  medium: 'w-12 h-12 text-sm',
  large: 'w-20 h-20 text-lg',
};

export const Avatar: React.FC<AvatarProps> = ({
  firstName = '',
  lastName = '',
  profileImageUrl,
  size = 'medium',
}) => {
  const initials = `${firstName?.[0] || ''}${lastName?.[0] || ''}`.toUpperCase() || 'U';
  const sizeClass = sizeClasses[size];

  if (profileImageUrl) {
    return (
      <img
        src={profileImageUrl}
        alt={`${firstName} ${lastName}`}
        className={`${sizeClass} rounded-full object-cover shrink-0`}
      />
    );
  }

  return (
    <div
      className={`${sizeClass} rounded-full bg-volt flex items-center justify-center text-accent-foreground font-medium shrink-0`}
    >
      {initials}
    </div>
  );
};

